import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { themeColors } from './themeColors';

export default makeStyles((theme: Theme) => ({
  promocodesTableCell: {
    fontWeight: 'bold',
    '&.MuiTableCell-root': {
      borderBottom: 'unset',
      padding: '9px 16px',
    },
  },

  promocodesStatusActive: {
    color: themeColors.success,
  },
  promocodesStatusUsed: {
    color: themeColors.inactive,
  },
  promocodesCodeColumn: {
    width: 234,
  },
}));
